import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { Uploader } from 'rsuite';
import { Button } from 'react-bootstrap';
import { Trans } from 'react-i18next';
import "./CreateProfile.css";

function CreateProfileUpload({
    fileOnChange,
    register,
    control
}) {
    const uploader = React.createRef();

    return (
        <>

            <div className='d-flex  justify-content-center text-center '>
                <Controller
                    control={control}
                    name={"UploadProfiles"}
                    refs={register("UploadProfiles")}
                    render={({ field: { onChange, onBlur, value } }) => (
                        <Uploader
                            action=""
                            draggable
                            multiple={false}
                            autoUpload={false}
                            onChange={(e) => {
                                onChange(e);
                                fileOnChange(e)
                            }}
                            accept=".doc, .docx, .pdf,.txt"
                            fileListVisible={false}
                            ref={uploader}
                            className='uploader-container'
                        >
                            <div style={{ /* height: 165, width: 466, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',borderRadius: '15px' */  }}  className='align-items-center justify-content-center d-flex'   >
                                <div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="0 0 1000 1000" fill={"var(--bs-primary)"} height="35" width="50">
                                            <g><path d="M850,974.5H150c-77.3,0-140-65.3-140-145.9V646.3c0-20.1,15.7-36.5,35-36.5h70c19.3,0,35,16.3,35,36.5v109.4c0,40.3,31.3,72.9,70,72.9h560c38.7,0,70-32.7,70-72.9V646.3c0-20.1,15.7-36.5,35-36.5h70c19.3,0,35,16.3,35,36.5v182.3C990,909.2,927.3,974.5,850,974.5L850,974.5z M784.5,449.2c-14.2,14.8-37.1,14.8-51.3,0L570,279.1v367.2c0,20.1-15.7,36.5-35,36.5h-70c-19.3,0-35-16.3-35-36.5V279.1L266.8,449.2c-14.2,14.8-37.1,14.8-51.3,0l-51.3-53.4c-14.2-14.8-14.2-38.7,0-53.4L453.2,41.1c1.2-1.3,23.7-15.6,46.4-15.6c22.9,0,45.9,14.3,47.2,15.6l289.1,301.2c14.2,14.8,14.2,38.7,0,53.4L784.5,449.2L784.5,449.2z" /></g>
                                        </svg>
                                    </div>
                                    <div className='my-1  mb-2'>
                                        <Trans defaults="Drag & Drop Profile Here" i18nKey="dragAndDropProfile" />
                                        </div>
                                    <div className='my-1'>
                                        <Trans defaults="or" i18nKey="or" />
                                        </div>
                                    <div className='pb-2'>
                                        <Button variant="primary" className='btn-sm'><Trans defaults='Browse' i18nKey="browse" /> <Trans defaults='profile' i18nKey="profile" /></Button>
                                    </div>
                                </div>
                            </div>
                        </Uploader>
                    )}
                />

            </div>
            <span className='ps-2 d-flex justify-content-center'>
                <Trans i18nKey="formatSizeWarningMessages" defaults="We accept only doc, docx, pdf and txt (MAX. 2 MB)"/>
            </span>
        </>
    );
}

CreateProfileUpload.propTypes = {
    fileOnChange: PropTypes.func,
    register: PropTypes.func,
    control: PropTypes.object
};

export default CreateProfileUpload;